import { FEATURE_FLAGS, useBooleanFlag } from "@src/services/feature-flags/feature-flags";
import { BACKFILL_SUBPATH, RECOMPUTE_INCIDENTS_SUBPATH, type PatriotTool } from "./routes";

/**
 * Whether the support user may use the Patriot backfill page: the
 * `patriot_tools_backfill` flag, which the API also checks server-side.
 */
export function useCanStartPatriotBackfill(): boolean {
  return useBooleanFlag(FEATURE_FLAGS.PATRIOT_TOOLS_BACKFILL);
}

/**
 * Whether the support user may use the Recompute incidents page: the
 * `monitoring_incident_recompute` flag, which the API also checks server-side.
 */
export function useCanRecomputeIncidents(): boolean {
  return useBooleanFlag(FEATURE_FLAGS.MONITORING_INCIDENT_RECOMPUTE);
}

/** Whether the landing page lists `tool`: every tool, except Patriot backfill and Recompute incidents while their flags are off. */
export function useIsPatriotToolOffered(): (tool: PatriotTool) => boolean {
  const canStartBackfill = useCanStartPatriotBackfill();
  const canRecomputeIncidents = useCanRecomputeIncidents();
  return (tool) => {
    if (tool.subpath === BACKFILL_SUBPATH) return canStartBackfill;
    if (tool.subpath === RECOMPUTE_INCIDENTS_SUBPATH) return canRecomputeIncidents;
    return true;
  };
}
